/* eslint-disable */

angular.module('services').service('Facebook', ($q, $window) => {

    let exports;
    /**
        The script tag HTML id for the FB JS SDK
        @type String
    */
    const SCRIPT_ID = 'facebook-jssdk';

    /**
        Indicates whether the debug version of the FB JS SDK is loaded
        @type Boolean
    */
    const SCRIPT_DEBUG = false;

    /**
        The Facebook application id
        @type String
    */
    const APP_ID = '438101322915896';

    /**
        The Facebook application url
        @type String
    */
    const APP_URL = 'https://www.facebook.com';

    /**
        The list of API methods that will be wrapped for handling
        common error scenarios together with the index in the arguments list
        for each method where the callback is passed.
        @type Array
    */
    const WRAP_API = [
        { f: 'api', cbIndex: 1 },
        { f: 'login', cbIndex: 0 },
        { f: 'logout', cbIndex: 0 },
        { f: 'getLoginStatus', cbIndex: 0 },
    ];

    /**
        The list of error codes return by the FB API that should be handled
        by retrying the call after a predefined timeout.
        @type Array
    */
    const RETRY_CODES = [1, 2, 4, 17];

    /**
        The timeout for reissueing a previous FB API call that resulted in
        an error code from {@link RETRY_CODES}.
        @type Number
    */
    const RETRY_TIMEOUT = 1000;

    /**
        The maximum number a call should be retried before dropping it.
        @type Number
    */
    const MAX_RETRIES = 3;

    /**
        The queue of wrapped calls that are issued.
        Calls are retried from this queue if the response error code indicates
        this. The call is removed from this queue once a call results in a
        success or in a particular error response that cannot be handled in a
        general way or the number of retries reaches the maximum value.
        @type Array
    */
    let queue = [];

    /**
        A deferred object for keeping the status of loading the FB SDK
        @type {$q.defer}
    */
    const deferred = $q.defer();

    /**
        A compiled template function to return the Facebook JS SDK URL
        taking into account the locale and the debug setting
        @type Function
    */
    const getScriptSrc = _.template(`//connect.facebook.net/<% print(locale || 'en_US'); %>/all${
        SCRIPT_DEBUG ? '/debug' : ''}.js`);

    /**
        Initializer for the Sandbox extension.
        Loads the Facebook JS SDK and sets up its initialization.
    */
    function init() {

        const fbJs = $window.document.getElementsByTagName('script')[0];
        const fbscript = $window.document.createElement('script');

        if ($window.document.getElementById(SCRIPT_ID)) {

            deferred.resolve();
            return;

        }

        fbscript.id = SCRIPT_ID;
        fbscript.src = getScriptSrc({ locale: '' });

        fbJs.parentNode.insertBefore(fbscript, fbJs);

        $window.fbAsyncInit = initAPI;

    }

    /**
        Initializes the Facebook JS SDK.
        Extends this modules export object with the FB JS SDK's API
        and takes care to wrap methods listed in {@link WRAP_API}
    */
    function initAPI() {

        FB.init({
            appId: APP_ID,
            status: true,
            cookie: true,
        });

        _.extend(
            exports,
            FB,
            _.reduce(WRAP_API, (o, w) => {

                o[w.f] = _.partial(wrap, w.f, w.cbIndex);
                return o;

            }, {}),
        );

        deferred.resolve();

    }

    /**
        Common wrapper for API calls that return similar responses.
        Pushes a call specification in the {@link queue} and makes the
        actual FB API call.
    */
    function wrap(f, cbIndex) {

        const rest = _.rest(arguments, 2);
        const cb = rest[cbIndex];

        // Keep a reference to the call specification so it can be reissued
        // later if necessary
        const call = {
            f,
            args: rest,
            cb,
            cbIndex,
            count: 0,
            deferred: $q.defer(),
        };
        queue.push(call);

        // Call the actual FB API
        callAPI(call);

        // Enhance the API by returning a promise
        return call.deferred.promise;

    }

    /**
        Handler for wrapped methods.
        If a response error code from {@link RETRY_CODES} arrives it
        reschedules the call to be reissued after {@link RETRY_TIMEOUT}.

        @param {Object} response
        @param {Object} call The call specification
    */
    function handle(call, response) {

        if (!response) {

            drop(call);
            return;

        }

        if (response.error && _.indexOf(RETRY_CODES, response.error) !== -1) {

            if (++call.count < MAX_RETRIES) {

                setTimeout(_.partial(callAPI, call), RETRY_TIMEOUT);

            } else {

                drop(call);

            }

        }

        drop(call);

        if (call.cb) {

            call.cb(response);

        }
        call.deferred.resolve(response);

    }

    /**
        Drops a call from the queue.
        @param {Object} call A call specification object
    */
    function drop(call) {

        queue = _.without(queue, call);

    }

    /**
        Makes the actual FB API call based on a call specification.
        @param {Object} call A call specification object
        @param {String} call.f The method name
        @param {Array} call.args The original arguments
        @param {Function} call.cb The passed callback
        @param {Number} call.cbIndex The arguments index where the callback is
        @param {Number} call.count The number of times this call was retried
    */
    function callAPI(call) {

        // Make a copy of the original arguments so we don't alter them
        const args = call.args.slice();
        // Replace the original callback argument with {@link handle}
        args.splice(call.cbIndex, 1, _.partial(handle, call));

        // Call the original API method
        FB[call.f](...args);

    }

    /**
        Returns a promise that will be resolved when the FB SDK is loaded
        @returns {jQuery.Promise}
    */
    function loaded() {

        return deferred.promise;

    }

    /**
        Display Facebook authentification page.
     */
    function dialogOAuth() {

        const path = '/dialog/oauth';
        const query = `?client_id=${APP_ID}&scope=email` +
                `&redirect_uri=${encodeURIComponent($window.location.href)}`;

        $window.location = APP_URL + path + query;

    }

    /**
        The exported API of this module.

        This is a clone of the FB JS SDK so all possible calls are available
        through this object, with the exception of the wrapped methods which
        handle common error scenarios on top of the actual FB calls.
    */
    exports = {
        init,
        loaded,
        dialogOAuth,
    };

    return exports;

});



// WEBPACK FOOTER //
// ./scripts/common/services/facebook.js